var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        { attrs: { id: _vm.id, "no-gutters": "" } },
        [
          _vm.sidebar
            ? _c(
                "b-col",
                {
                  staticClass:
                    "flex-column justify-content-between d-none d-lg-flex",
                  attrs: {
                    id: _vm.clientSignup
                      ? "app-left-side-client"
                      : "app-left-side",
                    cols: "3",
                  },
                },
                [
                  _c(
                    "b-row",
                    { staticClass: "m-2 justify-content-start" },
                    [
                      _c(
                        "b-col",
                        {
                          attrs: {
                            cols: _vm.clientSignup ? "12" : "10",
                            sm: "9",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "logo logo-login" },
                            [
                              _vm.loading
                                ? _c("b-skeleton", {
                                    attrs: { width: "100%", height: "100%" },
                                  })
                                : _c("img", {
                                    staticClass: "logo-img",
                                    attrs: { src: _vm.logo, alt: "" },
                                  }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    {
                      staticClass: "justify-content-center position-relative",
                      class: { "mb-4": _vm.$i18n.locale !== "fr-CA" },
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _vm.clientSignup
                        ? _c("img", {
                            staticClass: "img-responsive left-side-laptop",
                            attrs: {
                              src: require("@Shared/@Assets/img/sign-up-left.svg"),
                              alt: "",
                            },
                          })
                        : _c("img", {
                            staticClass: "img-responsive left-side-laptop",
                            attrs: {
                              src: require("@Client/@Assets/img/Notebook.png"),
                              alt: "",
                            },
                          }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          class: _vm.clientSignup
                            ? "description"
                            : "px-3 column-divider-bottom mb-4",
                          attrs: { cols: "10" },
                        },
                        [
                          _vm.loading
                            ? [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { height: "3rem" },
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", { attrs: { height: "1rem" } }),
                              ]
                            : [
                                _c(
                                  "h1",
                                  {
                                    class: _vm.clientSignup
                                      ? "bold title-client"
                                      : "bold title-broker",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.title) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.clientSignup
                                  ? _c("p", { staticClass: "bold subtitle" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("account.oneStepCloser")
                                          ) +
                                          "\n            "
                                      ),
                                    ])
                                  : _c("p", { staticClass: "bold" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.subtitle) +
                                          "\n            "
                                      ),
                                    ]),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "px-3 d-xl-block d-lg-none mb-md-4",
                          attrs: { cols: "6", xl: "3" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image-cropper" },
                            [
                              _vm.loading
                                ? _c("b-skeleton", {
                                    attrs: {
                                      type: "avatar",
                                      width: "100%",
                                      height: "100%",
                                    },
                                  })
                                : _c("img", {
                                    staticClass: "profile-pic",
                                    attrs: {
                                      width: "100%",
                                      height: "100%",
                                      src: _vm._f("avatarPlaceholder")(
                                        _vm.agentAccountDetails
                                      ),
                                      alt: "",
                                    },
                                  }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          class: _vm.clientSignup ? "px-3 mb-3 ml-5" : "px-3",
                          attrs: { cols: "10", xl: "7" },
                        },
                        [
                          _vm.loading
                            ? [
                                _c("b-skeleton", {
                                  staticClass: "mb-2",
                                  attrs: { height: "2rem" },
                                }),
                                _vm._v(" "),
                                _c("b-skeleton", { staticClass: "mb-1" }),
                                _vm._v(" "),
                                _c("b-skeleton", { staticClass: "mb-1" }),
                              ]
                            : [
                                _c("h4", { staticClass: "bold" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.agentAccountDetails.givenName
                                      ) +
                                      "\n              " +
                                      _vm._s(
                                        _vm.agentAccountDetails.familyName
                                      ) +
                                      "\n            "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "bold m-0 text-truncate" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.agentAccountDetails.phoneNumber
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "bold m-0 text-truncate" },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.agentAccountDetails.email) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.showAgentLicenseNumber &&
                                _vm.agentAccountDetails
                                  .licenseRegistrationNumber
                                  ? _c(
                                      "p",
                                      { staticClass: "bold m-0 text-truncate" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t(
                                                "global.words.agentLicense"
                                              )
                                            ) +
                                            " #\n              " +
                                            _vm._s(
                                              _vm.agentAccountDetails
                                                .licenseRegistrationNumber
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.licenseType
                                  ? _c(
                                      "p",
                                      { staticClass: "bold text-truncate" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("global.words.licenseType")
                                            ) +
                                            ":\n              " +
                                            _vm._s(_vm.licenseType) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.allowLogout
                        ? _c(
                            "b-col",
                            { staticClass: "px-3", attrs: { cols: "10" } },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "logout-btn m-0 clickable",
                                  on: { click: _vm.handleLogout },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-sign-out fa-rotate-180",
                                    attrs: { "aria-hidden": "true" },
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$t("global.words.logout")) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-flex flex-column min-vh-100",
              class: { "col-lg-9 offset-lg-3 offset-0": _vm.sidebar },
              attrs: { cols: "12" },
            },
            [
              _vm._t("navbar"),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: _vm.sideClass + " " + (_vm.showFooter ? "h-100" : ""),
                  attrs: { id: "app-container" },
                },
                [_vm._t("default")],
                2
              ),
              _vm._v(" "),
              _vm.showFooter
                ? _c("page-footer", { attrs: { "show-lang-selector": "" } })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.sessionTerminated ? _c("public-session-terminated") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }